import React, { useEffect, useState } from 'react';
import SkuList from './components/SkuList';
import { getKeyProviders } from '../../actions/keyProviderActions';
import RequestKeys from '../requests/slideout/RequestKeys';
import Loading from '../common/Loading';
import { userIs } from '../auth/authUtils';
import userTypes from '../../constants/userTypes';
import BasicGameDetails from './components/BasicGameDetails';
import SlidingPane from 'react-sliding-pane';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { connect } from 'react-redux';

export interface GameBasicProps {
  keyProviders: any;
  getKeyProviders: () => void;
  setCompleteRequestSlideoutOpen: (open: boolean) => void;
  game: any;
}

function ManageGame({
  keyProviders,
  getKeyProviders,
  setCompleteRequestSlideoutOpen,
  game,
}: GameBasicProps) {
  const currentUser = useAppSelector((state) => state.auth);

  const { id } = useParams();
  const [reload] = useState<any>();
  const [requestKeysSlideoutOpen, setRequestKeysSlideoutOpen] = useState(false);
  const [requestKeysSKU, setRequestKeysSKU] = useState<any>();

  useEffect(() => {
    if (!keyProviders) {
      getKeyProviders();
    }
  }, [keyProviders, getKeyProviders, id]);

  const handleOnRequestKeys = (e: any, sku: any) => {
    e.cancelBubble = true;
    setRequestKeysSKU(sku);
    setRequestKeysSlideoutOpen(true);
    return false;
  };

  return game ? (
    <>
      <BasicGameDetails game={game}></BasicGameDetails>

      <SkuList
        reload={reload}
        gameId={game.id}
        publisherCompanyId={game.publisherCompanyId}
        onRequestKeys={handleOnRequestKeys}
        canRequestKeys={userIs(currentUser, userTypes.REQUESTER)}
        canUploadKeys={userIs(currentUser, userTypes.UPLOADER)}
        locked={game.isArchived}
        keyProviders={keyProviders}
        itemsChecked={[]}
        setItemsChecked={() => { }}
      />

      {requestKeysSKU && (
        <SlidingPane
          isOpen={requestKeysSlideoutOpen}
          hideHeader={true}
          from="right"
          className="small-side-panel"
          onRequestClose={() => setRequestKeysSlideoutOpen(false)}
        >
          <RequestKeys
            gameId={requestKeysSKU.gameId}
            skuId={requestKeysSKU.skuId}
            done={() => {
              setRequestKeysSlideoutOpen(false);
              setCompleteRequestSlideoutOpen(true);
            }}
            cancel={() => setRequestKeysSlideoutOpen(false)}
          />
        </SlidingPane>
      )}
    </>
  ) : (
    <Loading></Loading>
  );
}

function mapStateToProps(state: any) {
  return {
    keyProviders: state.keyProviders,
  };
}

const mapDispatchToProps = {
  getKeyProviders,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageGame);
